var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('textarea',{staticClass:"form-control",class:{
      'is-invalid': _vm.field.$error,
      'is-valid': !_vm.field.$invalid,
    },attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }